<template>
    <div>
        <navbar></navbar>
        <div v-if="loading">
            <Loader></Loader>
        </div>
        <div class="modal" v-bind:class="{'is-active': adding_user}">
            <div class="modal-background"></div>
            <div class="modal-content modal-box">
                <article class="card">
                    <error-display v-if="new_user_has_error" :errors="new_user_errors"></error-display>
                    <form class="new-user-form" @submit.prevent="addUser">
                        <div class="field">
                            <label class="label is-pulled-left">Name</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="Jon Doe" v-model="new_user_name">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label is-pulled-left">Email</label>
                            <div class="control">
                                <input class="input" type="email" placeholder="Jon.Doe@email.com"
                                       v-model="new_user_email">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label is-pulled-left">Temporary Password</label>
                            <div class="control">
                                <input class="input" type="text" v-model="new_user_password">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label is-pulled-left">Default Location</label>
                            <div class="select">
                                <select v-model="new_user_default_locations">
                                    <option disabled value="">Select A Location</option>
                                    <option
                                            v-for="option in locations"
                                            :key="option.id"
                                            v-bind:value="option">
                                        {{ option.location }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <hr>
                        <div>
                            <button class="button is-info level-item" v-bind:class="{'is-loading': new_user_submitting}">Add User</button>
                        </div>
                    </form>
                </article>
            </div>
            <button class="modal-close is-large" aria-label="close" @click="adding_user = !adding_user"></button>
        </div>
        <section class="section container">
            <div class="columns">
                <div class="column is-one-third box">
                    <div class="level">
                        <div class="level-left">
                            <p class="level-item subtitle is-5">Users</p>
                        </div>
                        <div class="level-right">
                            <button class="button is-info level-item" @click="adding_user = !adding_user">Add User
                            </button>
                        </div>
                    </div>
                    <div class="container">
                        <hr>
                    </div>
                    <div class="container">
                        <div v-for="user in users " class="list is-hoverable">
                            <a class="list-item" @click="selectUser(user)">
                                {{user.name}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="column box container">
                    <user-detail v-if="currentUser" :user="currentUser" @deleted_user="getUsers"></user-detail>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Loader from "../components/Loader";
    import UserDetail from "../components/UserDetail";
    import ErrorDisplay from "../components/ErrorDisplay";

    export default {
        name: "Admin",
        components: {ErrorDisplay, UserDetail, Navbar, Loader},
        data() {
            return {
                loading: false,
                users: [],
                currentUser: null,
                adding_user: false,
                locations: [],
                locations_placeholder: '',
                new_user_default_locations: '',
                new_user_name: '',
                new_user_email: '',
                new_user_password: '',
                new_user_submitting: false,
                new_user_has_error: false,
                new_user_errors: []
            }
        },
        mounted() {
            this.getUsers();
            this.getOptions();
            this.generatePassword();
        },
        methods: {
            getUsers() {
                this.loading = true;
                let url = process.env.VUE_APP_API;
                url = url + "/admin/users";
                if (!this.$store.getters.isSuperAdmin) {
                    let locations = this.$store.getters.adminLocations.map(value => value.id);
                    url = url + "?filters[locations]=" + locations.join(',');
                }
                this.$http.get(url)
                    .then(response => {
                        this.users = response.data.data;
                        this.loading = false;
                        this.currentUser = null;
                    })
            },
            selectUser(user) {
                this.currentUser = user;
            },
            getOptions() {
                if (this.$store.getters.isSuperAdmin) {
                    let url = process.env.VUE_APP_API
                    url = url + '/locations/'
                    this.$http.get(url)
                        .then(response => {
                            this.locations = response.data.data
                            this.locations_placeholder = "Choose a Section"
                        })
                } else {
                    this.locations = this.$store.getters.adminLocations;
                }
            },
            generatePassword() {
                var length = 8,
                    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                    retVal = "";
                for (var i = 0, n = charset.length; i < length; ++i) {
                    retVal += charset.charAt(Math.floor(Math.random() * n));
                }
                this.new_user_password = retVal;
            },
            addUser() {
                this.new_user_submitting = true;
                let data = {data: {
                        name: this.new_user_name,
                        email: this.new_user_email,
                        default_location: this.new_user_default_locations.id,
                        password: this.new_user_password
                    }};

                let url = process.env.VUE_APP_API;
                url = url + "/admin/users"
                this.$http.post(url,data)
                    .then(resp => {
                        this.new_user_submitting = false;
                        this.adding_user = false;
                        this.getUsers();
                    })
                    .catch(err => {
                        this.new_user_submitting = false;
                        this.new_user_has_error = true
                        this.new_user_errors = err.response.data.errors
                    })
            }
        }
    }
</script>

<style scoped>
    .card {
        border-radius: 10px;
        padding: 35px;
    }
    .box {
        margin: 15px;
    }
</style>